import { render, staticRenderFns } from "./resetPassSave.vue?vue&type=template&id=7330f82b&scoped=true"
import script from "./resetPassSave.vue?vue&type=script&lang=js"
export * from "./resetPassSave.vue?vue&type=script&lang=js"
import style0 from "./resetPassSave.vue?vue&type=style&index=0&id=7330f82b&prod&scoped=true&lang=css"
import style1 from "./resetPassSave.vue?vue&type=style&index=1&id=7330f82b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7330f82b",
  null
  
)

export default component.exports